__turbopack_context__.v({
  "Menul2description": "mega-nav-desktop-module__7CZIya__Menul2description",
  "active": "mega-nav-desktop-module__7CZIya__active",
  "bannerImage": "mega-nav-desktop-module__7CZIya__bannerImage",
  "dropdown": "mega-nav-desktop-module__7CZIya__dropdown",
  "dropdown--scrollable": "mega-nav-desktop-module__7CZIya__dropdown--scrollable",
  "dropdown--withCallout": "mega-nav-desktop-module__7CZIya__dropdown--withCallout",
  "dropdownBannerCol": "mega-nav-desktop-module__7CZIya__dropdownBannerCol",
  "dropdownTitle": "mega-nav-desktop-module__7CZIya__dropdownTitle",
  "dropdownVisible": "mega-nav-desktop-module__7CZIya__dropdownVisible",
  "innerMenuWrap": "mega-nav-desktop-module__7CZIya__innerMenuWrap",
  "innerMenuWrap--withCallout": "mega-nav-desktop-module__7CZIya__innerMenuWrap--withCallout",
  "linkGroup": "mega-nav-desktop-module__7CZIya__linkGroup",
  "links": "mega-nav-desktop-module__7CZIya__links",
  "mainLink": "mega-nav-desktop-module__7CZIya__mainLink",
  "megaMenu": "mega-nav-desktop-module__7CZIya__megaMenu",
  "megaMenuCallout": "mega-nav-desktop-module__7CZIya__megaMenuCallout",
  "megaMenuCalloutImage": "mega-nav-desktop-module__7CZIya__megaMenuCalloutImage",
  "megaMenuCalloutTitle": "mega-nav-desktop-module__7CZIya__megaMenuCalloutTitle",
  "megaMenuCalloutWrapper": "mega-nav-desktop-module__7CZIya__megaMenuCalloutWrapper",
  "megaMenuL2": "mega-nav-desktop-module__7CZIya__megaMenuL2",
  "multiSlide": "mega-nav-desktop-module__7CZIya__multiSlide",
  "navbarLink": "mega-nav-desktop-module__7CZIya__navbarLink",
  "navbarLink--default": "mega-nav-desktop-module__7CZIya__navbarLink--default",
  "navbarLink--grid": "mega-nav-desktop-module__7CZIya__navbarLink--grid",
  "navbarLink--list": "mega-nav-desktop-module__7CZIya__navbarLink--list",
  "slideDown": "mega-nav-desktop-module__7CZIya__slideDown",
  "subLinks": "mega-nav-desktop-module__7CZIya__subLinks",
});
